import qs from 'qs';

import type { AppRouteBeforeServerRenderContext } from 'src/shared/routes';

import { getTopicSlug } from 'src/app/shared/api/topics';

/**
 * `handleTopicsRedirect` redirects to `/topic/:slug` if the topic page by
 * slug is returned from `topicPageBySlug`, meaning it should point to
 * the topic page.
 */
export const handleTopicsRedirect = async ({
	utilities,
	redirect,
	params: { slug },
	query,
}: AppRouteBeforeServerRenderContext): Promise<void> => {
	const { slug: topicSlug } = await getTopicSlug(utilities, slug);
	const queryString = qs.stringify(query, { addQueryPrefix: true });

	if (topicSlug && topicSlug.length > 0) {
		const targetPath = `/topic/${slug}${queryString}`;
		redirect(targetPath, true);
	}
};
